import script from "./select-bank-account-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./select-bank-account-modal.vue?vue&type=script&setup=true&lang=ts"

import "./select-bank-account-modal.vue?vue&type=style&index=0&id=1be1a3b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be1a3b8"]])

export default __exports__